import { render, staticRenderFns } from "./SingleSelectField.vue?vue&type=template&id=1fbf9dd4&scoped=true&"
import script from "./SingleSelectField.vue?vue&type=script&lang=ts&"
export * from "./SingleSelectField.vue?vue&type=script&lang=ts&"
import style0 from "./SingleSelectField.vue?vue&type=style&index=0&id=1fbf9dd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf9dd4",
  null
  
)

export default component.exports